/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Invoke_ApiInputs */



/**
* | output |
* | --- |
* | "Direct API access (invoke_api)" |
*
* @param {Spaces_Tool_Grants_Invoke_ApiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_invoke_api = /** @type {((inputs?: Spaces_Tool_Grants_Invoke_ApiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Invoke_ApiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Direkter API-Zugriff (invoke_api)")
	return /** @type {LocalizedString} */ ("Direct API access (invoke_api)")
});